import { categoryDetails as services1} from "@/content/services/1";
import { categoryDetails as services2} from "@/content/services/2";
import CategoryHighlights from "@/ui/category-highlights/category-highlights";
import {MetaTags} from "@/lib";
import LocalBusinessSeo from "@/lib/seo/local-business-seo";
import {BUSINESS_NAME} from "@/content";
import React from "react";
import ServiceTiles from "@/ui/service-tiles/service-tiles";
import ContentTitles from "@/ui/content-titles/content-titles";
import ContactUsBlock from "@/ui/contact-us-block";
import {GoogleServiceArea} from "@/ui/google-service-area/GoogleServiceArea";


export default function Services() {

  return (
      <div className='bg-white pt-10'>
        <LocalBusinessSeo />
        <MetaTags />
        <div >
            <ContentTitles
            overline={BUSINESS_NAME}
            title="Our Services"
            subTitle="A page for all our services"
            titleVariant="h2"
            titleComponent="h1"
                />
            <CategoryHighlights category={services1}  alternate showMainCategoryLink />
            <ServiceTiles service={services1}/>
            <CategoryHighlights category={services2} alternateBackground alternate showMainCategoryLink />
            <ServiceTiles service={services2}/>
        </div>
          <ContactUsBlock />
          <div className='py-10'>
            <GoogleServiceArea />
          </div>
      </div>
  );
}
